export default "__VITE_ASSET__DZ5To_L1__"